module.exports = __webpack_public_path__ + "static/media/craft-11.ed87700f.svg";